import { useReactToPrint } from "react-to-print";
import { useContext } from "@/common/hooks";
import { PrivateContext } from "@/routes/PrivateRoute";
import { CommonLink, MaterialIcon } from "../components";

const PrintButton = ({ label, wrapperClassName, agRef, click = () => {} }) => {
  const { printRef } = useContext(PrivateContext);

  const reactToPrintFn = useReactToPrint({
    contentRef: agRef ? agRef : printRef,
    onBeforePrint: () => {
      return new Promise((resolve) => {
        click(true);
        setTimeout(() => {
          resolve();
        }, 500);
      });
    },
    onAfterPrint: () => {
      click(false);
    },
  });

  return (
    <div
      className={`d-flex justify-content-end mt-1 ${wrapperClassName} d-print-none`}
    >
      <div onClick={reactToPrintFn} className="d-flex">
        <MaterialIcon
          iconName="print"
          wrapperClassName="me-1 primary-color print"
        />
        <CommonLink>
          <span className="primary-color">{label}</span>
        </CommonLink>
      </div>
    </div>
  );
};

PrintButton.displayName = "PrintButton";
export default PrintButton;
